export default __webpack_public_path__ + "static/media/eu-logo.1a7bc00a.png";